import axios from 'axios';

const state = {};

const getters = {};

const actions = {
	// Apre una sessione "telefono come lettore barcode" per il magazzino.
	// Ritorna { token, room, url, qr, expiresAt, absoluteDeadline, ttl } oppure { error }.
	createSession: async context => {
		let url = 'qrscan/session';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},

	// Stato della sessione: serve a riagganciarsi a una sessione gia' aperta
	// (cambio pagina nel magazzino) e a capire se e' ancora valida.
	fetchSession: async (context, token) => {
		let url = `qrscan/session/${token}`;

		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			})
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},

	revokeSession: async (context, token) => {
		let url = `qrscan/session/${token}/revoke`;

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				},
			)
			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { error: err.response ? err.response.data : err.message };
			});
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
